import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { prepareHeaders } from '@/core/utils/prepareHeaders.ts'
import { getApiUrl } from '@/core/utils/getApiUrl.ts'

export const forshawRestApi = createApi({
  reducerPath: 'forshawRestApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl(),
    prepareHeaders,
  }),
  endpoints: (builder) => ({
    logout: builder.mutation<void, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'DELETE',
        body: {
          logout_type: 'web',
        },
      }),
    }),
    loginByToken: builder.mutation<{ token: string }, string>({
      query: (authToken: string) => ({
        url: '/auth/login_by_token',
        method: 'POST',
        body: {
          authToken,
        },
      }),
    }),
  }),
})

export const { useLogoutMutation, useLoginByTokenMutation } = forshawRestApi
